module.exports = __webpack_public_path__ + "prod/20260407172207/img/service.edbff227.png";